import React from "react";

const FlightLine = () => {
  return (
    <>
      <div className=" w-[200px]  flightLine departure relative w-full h-0 mt-2.5 border border-dashed border-gray-300 icon before:content-['🛧'] before:absolute before:top-1/2 before:left-1/2 before:transform before:-translate-x-1/2 before:-translate-y-1/2 before:text-gray-400 before:rotate-90 before:text-xl before:font-bold">
        <div className="absolute top-1/2 left-[-2px] transform -translate-y-1/2 w-2.5 h-2.5 border border-gray-300 rounded-full bg-white"></div>
        <div className="absolute top-1/2 right-[-2px] transform -translate-y-1/2 w-2.5 h-2.5 border border-gray-300 rounded-full bg-gray-300"></div>
      </div>
    </>
  );
};

export default FlightLine;
